import { Timestamp } from "firebase/firestore";
import z from "zod";

export const timestampSchema = z.instanceof(Timestamp);

export const serverTimestampSchema = timestampSchema.nullable();
